import React, {useEffect, useState} from 'react';
import i18n from "../../i18n";
import { useLocation } from 'react-router-dom';
import {useTranslation} from "react-i18next";
import PageTitle from "../../components/Commons/PageTitle";
import Helpbox from "../../components/UI/Helpboxes/Helpbox";
import axios from "../../axios-defaults";
import Spinner from "../../components/UI/Spinner";
import parse from "html-react-parser";

const TermsAndConditions = () => {
    const location = useLocation();
    const {t,i18n} = useTranslation();
    const [loading, setLoading] = useState(true);
    const [pageTitle, setPageTitle] = useState(null);
    const [pageHtml, setPageHtml] = useState(null);

    useEffect(async() => {
        setLoading(true);
        let pageIDtoGet = '';
        if(location.pathname === '/privacy'){
            setPageTitle(t('breadcrumbs.privacy'));
            if(i18n.language === "fr"){
                pageIDtoGet = PRIVACY_FR;
            }else{
                pageIDtoGet = PRIVACY_EN;
            }
        }else if(location.pathname === '/conditions'){
            setPageTitle(t('breadcrumbs.termsandconditions'));
            if(i18n.language === "fr"){
                pageIDtoGet = TERMS_FR;
            }else{
                pageIDtoGet = TERMS_EN;
            }
        }
        if(pageIDtoGet !== ''){
            let urlToGet = `/wordpress/v2/pages/` + pageIDtoGet;
            await axios.get(urlToGet)
                .then(response => {
                    let pageHtml = response.data.content.rendered;
                    setPageHtml(pageHtml);
                    setLoading(false);
                }).catch(error => {
                setLoading(false);
                console.log('[TermsAndConditons.js] : Ajax error in getData() Terms', error.message)
            });
        }
    }, [t])

    return (

        < React.Fragment>
            <div className="container container--larger faqs">
                <div className="row flex flex--wrap">
                    <div className="col-md-6">
                        <PageTitle title={pageTitle}/>
                    </div>
                    <div className="col-md-6 flex flex--justify-end">
                        <Helpbox/>
                    </div>
                </div>
                <br/>
                <div className="accordions">
                    {loading || pageHtml === null ? <Spinner/> : parse(pageHtml)}
                </div>
            </div>
        </React.Fragment>
    )
};

export default TermsAndConditions;
